<script lang="ts">
	import { injectTranslation, showToast } from '@repo/commons/utils'
	import { locale, t } from 'svelte-i18n'
	import { toastsStore } from '@repo/commons/store'
	import { SETTING_KEYS, useSetting } from '@repo/commons/settings'
	import { ToastType } from './Toast.svelte'
	import Button, { ButtonSize, ButtonType } from './Button.svelte'
	import Tooltip from './Tooltip.svelte'

	interface Props {
		docSubpath: string
		title: string
	}

	let { docSubpath, title }: Props = $props()
	const { hideDocumentationLinks } = useSetting({
		hideDocumentationLinks: SETTING_KEYS.HIDE_DOCUMENTATION_LINKS
	})

	const escapeHtml = (value: string): string =>
		value.replace(
			/[&<>"']/g,
			(character) =>
				({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character] ??
				character
		)

	const tooltipHtml = $derived(
		injectTranslation($t('DocsLink.ClickToRead'), { title: escapeHtml(title) })
	)
	const documentationLanguage = $derived($locale?.toLowerCase().startsWith('de') ? 'de' : 'en')

	const openDocumentation = async (): Promise<void> => {
		try {
			const response = await fetch(
				`/api/shared/documentation/${encodeURIComponent(docSubpath)}?language=${documentationLanguage}`
			)
			if (!response.ok) {
				showToast(toastsStore, {
					message: $t('DocsLink.unavailable'),
					type: ToastType.ERROR
				})
				return
			}

			const payload: { url?: string } = (await response.json()) as { url?: string }
			if (payload.url) window.open(payload.url, '_blank', 'noopener,noreferrer')
		} catch (error) {
			console.error('Failed to open documentation:', error)
			showToast(toastsStore, {
				message: $t('DocsLink.unavailable'),
				type: ToastType.ERROR
			})
		}
	}
</script>

{#if hideDocumentationLinks.value !== true}
	<Tooltip html={tooltipHtml} position="top" tooltipSize="small">
		<Button
			buttonType={ButtonType.TRANSPARENT}
			buttonSize={ButtonSize.EXTRA_SMALL}
			rounded
			iconProps={{ name: 'questionMarkFill', class: 'text-brand' }}
			onclick={openDocumentation}
		/>
	</Tooltip>
{/if}
